import * as messageConfig from "./messages"

declare var navigator: any

export const i18n = (key: string, locale?: string) => {
  const defaultLang = "en-US";
  var lang = locale || (
    typeof navigator === 'undefined' ? defaultLang : navigator.language || navigator.userLanguage
  );
  var localeKey = messageConfig.messages[lang] ? lang : defaultLang;
  var message = messageConfig.messages[localeKey][key];
  return  message ? message : key;
};
